// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-picker{left:50%;position:absolute!important;top:50%;transform:translate(-50%,-100%)}.custom-dialog .v-card,.v-dialog__content{overflow:visible!important}.custom-dialog .v-card{height:600px!important;max-height:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
